import type {FinishedResponseInteractionService} from 'shared/services';
import type {Dimensions, Exemplar, Regal} from 'src/typings';
import type ExemplarPlacementDataService from '../../exemplar-placement.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';

const MAX_DIMENSION = 500;

export default class ExemplarPlacementPresenter {
    public static readonly serviceName = 'exemplarPlacementPresenter';

    /*@ngInject*/
    constructor(private exemplarPlacementDataService: ExemplarPlacementDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async loadPlacement(exemplar: Exemplar): Promise<Regal | undefined> {
        try {
            const placement = await this.exemplarPlacementDataService.getExemplarPlacement(exemplar.id);
            if (placement) {
                placement.dimensions = this.getDimensionsByMaxSide(placement.mapWidth, placement.mapHeight, MAX_DIMENSION);
            }
            return placement;
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }

    private getDimensionsByMaxSide(width: number, height: number, max: number): Dimensions {
        if (width > max || height > max) {
            const aspectRatio = width / height;

            if (width > height) {
                width = max;
                height = Math.round(width / aspectRatio);
            } else {
                height = max;
                width = Math.round(height * aspectRatio);
            }
        }
        return {
            width,
            height
        };
    }
}
